var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol _gap-6", attrs: { role: "list" } },
    _vm._l(_vm.exploreTags, function (tag) {
      return _c(
        "div",
        {
          key: tag.sectionKey,
          attrs: {
            role: "listitem",
            "data-qa": `explore-section:${tag.title}`,
          },
        },
        [
          _c(
            "home-section-title",
            { staticClass: "_mb-1", attrs: { "icon-name": tag.icon } },
            [_vm._v("\n            " + _vm._s(tag.title) + "\n        ")]
          ),
          _vm._v(" "),
          _c("project-explorer", {
            attrs: {
              tags: tag.items,
              "default-tag-key": tag.defaultTagKey,
              source: "homepage",
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }